/**
 * Created by rmarquez on 06/12/2017.
 */

import Immutable    from 'immutable';
import restService  from 'RestService.js';
import constants    from 'Constants.js';
import undoService from 'UndoService';
import listService from 'ListService';
import NotificationService from 'NotificationService';
import eventBus  from 'EventBus.js';
import textConstants        from 'TextConstants';

//===========================================================================================
// This service creates a new form folder on the host.
//===========================================================================================
class FormFolderService {
    //===========================================================================================
    // This method creates a new form folder on the host.
    //
    // The name of the form folder will be "New Folder", unless a form folder of that name exists for this user.
    // In that case the name is "New Folder (n)" where 'n' is the highest member of an increasing
    // sequence of 'n'.
    //
    // Return  object: 
    //
    //===========================================================================================
    newFormFolder(newFormFolderObjectParameters) {
        let parametersToSend = {
            name: newFormFolderObjectParameters.name,
            groupTypeId: newFormFolderObjectParameters.groupTypeId,
            groupParentId: newFormFolderObjectParameters.groupParentId
        };

        return new Promise((resolve, reject) => {
            this._newFormFolder(parametersToSend).then(result => {
                let formFolderId = result.formFolderId;
                undoService.add({
                    undo: () => {
                        restService.deleteFormFolder(formFolderId).then(response => {
                        eventBus.trigger('deletingForm', formFolderId, true);}); 
                    },
                    redo: () => {
                        this.newFormFolder(parametersToSend).then(result => {
                            eventBus.trigger('undeletingFormFolder', parametersToSend.groupTypeId,newFormFolderObjectParameters.isAddedOnRoot, parametersToSend.groupParentId,  result);
                        });
                    }
                }, textConstants.UNDO_NEW_FORM_FOLDER);
                resolve(result);
            }).catch(reject);
        });
    }

    _newFormFolder(formFolderDTO){
        return new Promise((resolve, reject) => {
            // Build request
            // Carry out request
            restService.addFormFolder(formFolderDTO).then(data => {
                const goodMsg = `App Folder "${data.Name}", ID "${data.GroupId}" created.`;
                const itemId = data.GroupId +'-' + data.formFolderId;
                let result = {  msg: goodMsg, formFolderId: data.GroupId, name: data.Name,
                    groupType: data.GroupId, itemId: itemId  };
                resolve(result);
            }, err => {
                if (err && typeof err === 'string') {
                    reject(err);
                } else if (err && typeof err === 'object' && err.responseText) {
                    const msg = JSON.parse(err.responseText);
                    reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                } else {
                    reject(err);
                }
            });
        });
    }

    deleteFormFolder(name, groupId, groupTypeId, groupParentId) {
        return new Promise((resolve, reject) => {
            this._deleteFormFolder(groupId, name).then(result => {
                undoService.add({
                    undo: () => {
                        this._unDeleteFormFolder(groupId).then(data =>{
                            if(listService.activeDashboardTab === 'forms') {
                                eventBus.trigger('undoFormFolder', data.name, data.groupId, data.groupTypeId, data.parentId, data.msg);
                            }
                            else{
                                NotificationService.success(`Folder ${name} was deleted. Clicking undo restores it.`);
                            }
                        });
                    },
                    redo: () => {
                        this._deleteFormFolder(groupId, name).then(result => {
                            if(listService.activeDashboardTab === 'forms') {
                                eventBus.trigger('deletingForm', groupId, true);
                            }
                            else{
                                NotificationService.success(`Folder ${name} was restored`);
                            }
                        });
                    }
                }, textConstants.UNDO_DELETE_FORM_FOLDER);
                resolve(result);
            }).catch(reject);
        });
    }

    _deleteFormFolder(groupId, folderName='') {
        return new Promise((resolve, reject) => {
            // Build request
            // Carry out request
            restService.deleteFormFolder(groupId).then(data => {
                const goodMsg = `App Folder "${folderName}", ID "${groupId}" deleted.`;
                const itemId = data.GroupId + '-' + data.formFolderId;
                let result = {
                    msg: goodMsg, formFolderId: data.formFolderId, name: data.Name,
                    groupType: data.GroupId, itemId: itemId
                };
                resolve(result);
            }, err => {
                if (err && typeof err === 'string') {
                    reject(err);
                } else if (err && typeof err === 'object' && err.responseText) {
                    const msg = JSON.parse(err.responseText);
                    reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                } else {
                    reject(err);
                }
            });
        });
    }

    _unDeleteFormFolder(groupId, folderName='') {
       return new Promise((resolve, reject) => {
            // Build request
            // Carry out request
            restService.unDeleteFormFolder(groupId).then(data => {
                const goodMsg = `App Folder "${data.Name}" , was restored.`;
                let result = {
                    msg: goodMsg, groupId: groupId, name: data.Name,
                    groupTypeId: data.GroupTypeId, parentId: data.GroupParentId
                };
                resolve(result);
            }, err => {
                if (err && typeof err === 'string') {
                    reject(err);
                } else if (err && typeof err === 'object' && err.responseText) {
                    const msg = JSON.parse(err.responseText);
                    reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                } else {
                    reject(err);
                }
            });
        });
    }
}

const formFolderService = new FormFolderService();
export default formFolderService;
